<template>
  <Header />
  <article>
    <div class="kv">
      <div class="caption">
        <h1>資源循環管理</h1>
      </div>
    </div>
    <section class="sect1">
      <div class="ctx">
        <div class="sectTit">全世界唯一未設置灰塘的電廠</div>
        <p>和平電力規劃之初即以零廢棄物、友善環境為首要考量，電廠、水泥廠與工業港形成「港電廠三合一循環經濟園區」，園區內 99% 以上的廢棄物可互相依存利用，發電過程產生的飛灰經由密閉吹運系統輸送至水泥廠，鍋爐底灰及脫硫石膏由卡車運送至水泥廠，煤灰及脫硫所產生的石膏完全回收再利用成水泥原料，這也使得和平電力成為全世界唯一沒有設置灰塘掩埋場的電廠。</p>
      </div>
    </section>
    <section class="sect2">
      <div class="ctx">
        <div class="imgContainer2-1">
          <img class="local1" src="@/assets/environmentCircular/pic2_02.png" />
          <img class="local2" src="@/assets/environmentCircular/pic2_03.png" />
          <img class="local3" src="@/assets/environmentCircular/pic2_04.png" />
          <div class="imgTit">港電廠三合一循環經濟園區</div>
        </div>
      </div>
    </section>
    <section class="sect3">
      <div class="ctx">
        <div class="contOver">
          <img src="../../assets/environmentCircular/pic3_01.png" />
        </div>
      </div>
    </section>
    <section class="sect4">
      <div class="ctx">
        <div class="gallery">
          <div class="imgContainer4-1">
            <div class="imgTit">脫硫石膏</div>
          </div>
          <div class="imgContainer4-2">
            <div class="imgTit">卡車運送鍋爐底灰</div>
          </div>
          <div class="imgContainer4-3">
            <div class="imgTit">飛灰吹運管</div>
          </div>
        </div>
      </div>
    </section>
  </article>
  <Footer />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ImgContainerAutoResize } from '../../util/util';
import Header from '../../components/Header.vue';
import Footer from '../../components/Footer.vue';

export default defineComponent({
  name: 'EnvironmentCircular',
  components: {
    Header,
    Footer
  },
  data() {
    return {
    }
  },
  methods:{
  },
  mounted() {
    new ImgContainerAutoResize(document.querySelector(".kv") as HTMLElement, 0.368);
    new ImgContainerAutoResize(document.querySelector(".imgContainer2-1") as HTMLElement, 0.7);
    new ImgContainerAutoResize(document.querySelector(".imgContainer4-1") as HTMLElement, 0.65);
    new ImgContainerAutoResize(document.querySelector(".imgContainer4-2") as HTMLElement, 1);
    new ImgContainerAutoResize(document.querySelector(".imgContainer4-3") as HTMLElement, 0.65);
  }
});
</script>

<style>
.kv {
  height: 700px;
  position: relative;
  background: url("@/assets/environmentCircular/kv.webp");
  background-position: center 45%;
  background-size: cover;
}

.kv .caption {
  width: 1200px;
  margin: 0 auto;
  padding: 25px 0;
  box-sizing: border-box;
}

.kv .caption h1 {
  margin: 0;
  display: inline-block;
  letter-spacing: 5px;
  font-weight: bold;
  font-size: 52px;
  color: #fff;
  text-shadow: 5px 5px 5px #00000066;
}

.sect1 .sectTit {
  margin: 0 0 10px;
  padding: 5px 0;
  box-sizing: border-box;
  display: inline-block;
  border-top: solid 1px #0C5F99;
  border-bottom: solid 1px #0C5F99;
  letter-spacing: 2px;
  font-size: 24px;
  color: #0C5F99;
}

.sect1 p {
  line-height: 2em;
}

.sect2 {
  background: url(../../assets/environmentCircular/sectBack2.png) center no-repeat;
  background-size: cover;
}

.sect2 .imgContainer2-1 {
  border-radius: 30px;
  overflow: hidden;
  position: relative;
  background: url(../../assets/environmentCircular/pic2_01.jpg) center no-repeat;
  background-size: cover;
}

.sect2 .imgContainer2-1 .local1 {
  width: 14%;
  position: absolute;
  left: 27%;
  top: 15%;
}

.sect2 .imgContainer2-1 .local2 {
  width: 10%;
  position: absolute;
  left: 48%;
  top: 48%;
}

.sect2 .imgContainer2-1 .local3 {
  width: 12%;
  position: absolute;
  left: 80%;
  top: 52%;
}

.sect2 .imgContainer2-1 .imgTit {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
  position: absolute;
  bottom: 0;
  text-align: center;
  color: #fff;
  background: #00000066;
}

.sect3 {
  background: #fff;
}

.sect3 img {
  width: 1200px;
}

.sect4 .gallery {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  border-radius: 30px;
  overflow: hidden;
}

.sect4 .gallery .imgContainer4-1 {
  flex: 0 0 60%;
  position: relative;
  background: url(../../assets/environmentCircular/pic4_01.jpg) center no-repeat;
  background-size: cover;
}

.sect4 .gallery .imgContainer4-2 {
  flex: 0 0 39%;
  margin: 0 0 8px;
  position: relative;
  background: url(../../assets/environmentCircular/pic4_02.jpg) center no-repeat;
  background-size: cover;
}

.sect4 .gallery .imgContainer4-3 {
  flex: 0 0 100%;
  position: relative;
  background: url(../../assets/environmentCircular/pic4_03.jpg) center no-repeat;
  background-size: cover;
}

.sect4 .gallery .imgContainer4-1 .imgTit,
.sect4 .gallery .imgContainer4-2 .imgTit,
.sect4 .gallery .imgContainer4-3 .imgTit {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
  position: absolute;
  bottom: 0;
  text-align: center;
  color: #fff;
  background: #00000066;
}

@media screen and (min-width: 1367px) and (max-width: 1600px) {
  .kv .caption h1 {
    font-size: 48px;
  }
}

@media screen and (min-width: 1201px) and (max-width: 1366px) {
  .kv .caption h1 {
    font-size: 44px;
  }
}

@media screen and (min-width: 768px) and (max-width: 1200px) {
  .kv .caption {
    width: 100%;
    padding: 10px 10px;
  }

  .kv .caption h1 {
    font-size: 40px;
  }
}

@media screen and (min-width: 1px) and (max-width: 767px) {
  .kv .caption {
    width: 100%;
    padding: 10px 10px;
  }

  .kv .caption h1 {
    font-size: 24px;
    text-shadow: 3px 3px 3px #00000066;
  }

  .sect2 .imgContainer2-1 .local1 {
    width: 28%;
    position: absolute;
    left: 20%;
    top: 3%;
  }

  .sect2 .imgContainer2-1 .local2 {
    width: 20%;
    position: absolute;
    left: 45%;
    top: 35%;
  }

  .sect2 .imgContainer2-1 .local3 {
    width: 24%;
    position: absolute;
    left: 75%;
    top: 35%;
  }

  .sect4 .gallery .imgContainer4-1 {
    flex: 0 0 100%;
  }

  .sect4 .gallery .imgContainer4-2 {
    flex: 0 0 100%;
    margin: 5px 0;
  }

  .sect4 .gallery .imgContainer4-3 {
    flex: 0 0 100%;
  }
}
</style>
